import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { kapaaConfig } from "./data";

export default function KapaaPage() {
  return <CityPageTemplate config={kapaaConfig} />;
}